import { palette } from './palette';
import subscriptionBg from 'assets/images/SubscriptionBg.webp';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
    },
    '& .hero-shaped__left-side': {
      flex: '0 0 50%',
      maxWidth: '50%',

      '@media(min-width: 900px) and (max-width: 1200px)': {
        flex: '0 0 50%',
        maxWidth: '50%',
      },
      '& .hero-shaped__image': {
        width: '50vw',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          width: '50vw',
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.simplySavings-container': {
    '& .normal-text': {
      fontWeight: 300,
    },
    '& .hero-home-button': {
      backgroundColor: `${palette.text.highlight} !important`,
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        backgroundColor: palette.background.header,
        color: palette.text.highlight,
        marginTop: 88,

        '& h1,& h2,& h3,& h4,& p': {
          color: palette.text.highlight,
        },
      },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.secondary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
      maxHeight: '640px',
    },
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.light,

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '@media screen and (min-width: 900px)': {
        '& .hero-background': {
          objectFit: 'contain',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '600px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '4.5rem',
        fontWeight: 600,
        letterSpacing: '-1.44px',
      },
      '& .home-hero-subtitle': {
        maxWidth: 565,
      },
    },
    '@media screen and (max-width: 900px)': {
      '& .home-hero-title': {
        fontSize: '2.5rem !important',
        fontWeight: 600,
        letterSpacing: '-0.8px',
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      backgroundColor: palette.surface.grey,
      '& .definition-variant-2': {
        padding: '0 !important',
      },
      '& .benefits-wrapper': {
        '& section-header__title': {
          weight: '600',
        },
        '& .section-header': {
          paddingBottom: 20,
        },
        '& .definition-service-description': {
          maxWidth: 380,
          margin: '0 auto',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: `url(${subscriptionBg})`,
        backgroundColor: palette.background.header,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        '@media(max-width: 900px)': {
          backgroundSize: 'cover',
        },
      },
      '& .section-header__title, .section-header__subtitle, .summary-text, .summary-subtext, .subscription-tabs-label':
        {
          color: `${palette.text.highlight} !important`,
        },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          '& .bold': {
            color: palette.text.primary,
          },
          '&:hover': {
            border: `none`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .MuiButton-containedSecondary': {
            '&:hover': {
              opacity: 1,
            },
          },
          '& .planCardDescription': {
            height: 'calc(100% - 64px)',
          },
        },
        '& .subscription-section': {
          '& .section-header': {
            maxWidth: 620,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .savings-summary-link': {
          color: palette.text.highlight,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .howitworks-title': {
        marginBottom: 20,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },
      '& .step-content': {
        maxWidth: 420,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
        height: 'auto',
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.secondary.main,
        color: palette.secondary.contrastText,
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.highlight,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        backgroundColor: palette.surface.grey,
      },
      '& .footer-bar': {
        display: 'none',
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.secondary.main,
      },
      '& .hero-static-title, .hero-static-subtitle': {
        color: palette.text.highlight,
      },
      '& .primary-static-button': {
        background: palette.text.highlight,
        color: palette.text.primary,
        boxShadow: 'none',
      },
      '@media screen and (min-width: 900px)': {
        '& .hero-static-section': {
          padding: '0px 32px',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: '1px solid',
        background: `${palette.text.highlight} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
            border: `1px solid ${palette.text.primary}`,
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        color: palette.text.highlight,
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
    },
    '& .faq-contact-section': {
      background: palette.surface.grey,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.primary.main,
      },
    },

    /* Footer Style */
    '& .footer-wrapper': {
      '& .MuiGrid-item': {
        maxWidth: 1500,
      },
    },
  },
};
